import { useContent } from '../../../../hooks/use-server-content';

export interface VehicleSelectorTabsContent {
    hide: boolean;
    vehicleSelectorTabsTitle: string;
    vinTabLabelDesktop: string;
    vinTabLabelMobile: string;
    vinInputBoxLabel: string;
    vinInputBoxPlaceHolder: string;
    findMyVinLabel: string;
    findMyVinLink: string;
    ymTabLabelDesktop: string;
    ymTabLabelMobile: string;
    yearDropdownLabel: string;
    modelDropdownLabel: string;
    submitSearchLabel: string;
    garageTabLabel: string;
}

export const useVehicleSelectorTabsContent = (): VehicleSelectorTabsContent | null => {
    const [content, getValueByName] = useContent(
        'common',
        'vehicle-selector-tabs'
    );
    let contentFragment: any = {};
    content?.elements.forEach(element => {
        contentFragment[`${element.name}`] = getValueByName(`${element.name}`);
    });
    if (contentFragment) {
        if (contentFragment.hide || !contentFragment.vehicleSelectorTabsTitle) {
            contentFragment = null;
        }
    }

    return contentFragment as VehicleSelectorTabsContent;
};
